import { __assign, __awaiter, __generator } from "tslib";
import { fetchHarmonyBuildId } from '@office-start/harmony-data-service';
import { getAppSecurityLevel, logDebugCacheEvent, } from '@office-start/instrumentation-service';
import { DataSecurityLevel, } from '@office-start/instrumentation-types';
import { logDiagnostic, logError, logFeature, } from '@office-start/telemetry-service';
import { getErrorInfo } from '../utilities/getErrorInfo';
import { getCapabilitiesAndContext } from './getCapabilitiesAndContext';
import { launchDocument } from './launchDocument';
import { launchDocumentWithUserPreferences } from './launchDocumentWithUserPreferences';
import { launchNativeFile } from './launchNativeFile';
import { logClick } from './logClick';
export var launchContent = function (contentLaunchParams, launchInstrumentationParams) { return __awaiter(void 0, void 0, void 0, function () {
    var result, eventName, dataSecurityLevel, params, buildId, document_1, capabilities, launchResult, disableDefaultLinkBehavior, event_1, prelaunchCallback, newContentParams, nativeLaunchResult, _a, error_1, _b, debugInfo, message;
    var _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    return __generator(this, function (_p) {
        switch (_p.label) {
            case 0:
                result = { success: false };
                eventName = 'launchContent';
                dataSecurityLevel = ((_c = contentLaunchParams.document) === null || _c === void 0 ? void 0 : _c.isLocalFile)
                    ? DataSecurityLevel.Enhanced
                    : DataSecurityLevel.Security;
                params = {};
                buildId = '';
                _p.label = 1;
            case 1:
                _p.trys.push([1, 20, 21, 22]);
                document_1 = contentLaunchParams.document;
                return [4 /*yield*/, getCapabilitiesAndContext()];
            case 2:
                capabilities = (_p.sent()).capabilities;
                return [4 /*yield*/, fetchHarmonyBuildId()];
            case 3:
                buildId = _p.sent();
                contentLaunchParams.isPwaInUwp = capabilities === null || capabilities === void 0 ? void 0 : capabilities.isPwaInUwp;
                if (!(capabilities.userPreferenceEnabled &&
                    contentLaunchParams.document)) return [3 /*break*/, 8];
                return [4 /*yield*/, launchDocumentWithUserPreferences(contentLaunchParams, launchInstrumentationParams)];
            case 4:
                launchResult = _p.sent();
                if (!(launchResult === null || launchResult === void 0 ? void 0 : launchResult.success)) return [3 /*break*/, 5];
                result = launchResult;
                return [3 /*break*/, 7];
            case 5: return [4 /*yield*/, launchDocument(contentLaunchParams, launchInstrumentationParams)];
            case 6:
                result = _p.sent();
                _p.label = 7;
            case 7: return [3 /*break*/, 19];
            case 8:
                if (!(!document_1.isEmailAttachment &&
                    // only try launching natively if a document is redeemed, since launching an unredeemed file using protocol
                    // or with local bridge wouldn't work
                    document_1.isRedeemed &&
                    !(contentLaunchParams.useDeeplinkUrl && document_1.deepLinkUrl))) return [3 /*break*/, 17];
                disableDefaultLinkBehavior = contentLaunchParams.disableDefaultLinkBehavior, event_1 = contentLaunchParams.event;
                prelaunchCallback = event_1 && !event_1.defaultPrevented && !disableDefaultLinkBehavior
                    ? function () { return event_1 === null || event_1 === void 0 ? void 0 : event_1.preventDefault(); }
                    : undefined;
                newContentParams = contentLaunchParams.newContentParams;
                nativeLaunchResult = undefined;
                _p.label = 9;
            case 9:
                _p.trys.push([9, 14, , 16]);
                return [4 /*yield*/, launchNativeFile({
                        appName: document_1.app,
                        filePath: document_1.canonicalUrl,
                        fileType: document_1.fileType,
                        prelaunchCallback: prelaunchCallback,
                        webUrl: document_1.webUrl,
                        templateBinaryUrl: newContentParams === null || newContentParams === void 0 ? void 0 : newContentParams.templateBinaryUrl,
                    })];
            case 10:
                nativeLaunchResult = _p.sent();
                logClick({
                    launchInstrumentationParams: launchInstrumentationParams,
                    success: nativeLaunchResult.success,
                });
                if (!nativeLaunchResult.success) return [3 /*break*/, 11];
                result = __assign(__assign({}, nativeLaunchResult), { result: 'Native' });
                return [3 /*break*/, 13];
            case 11: return [4 /*yield*/, launchDocument(contentLaunchParams, launchInstrumentationParams)];
            case 12:
                result = _p.sent();
                _p.label = 13;
            case 13: return [3 /*break*/, 16];
            case 14:
                _a = _p.sent();
                return [4 /*yield*/, launchDocument(contentLaunchParams, launchInstrumentationParams)];
            case 15:
                result = _p.sent();
                return [3 /*break*/, 16];
            case 16: return [3 /*break*/, 19];
            case 17: return [4 /*yield*/, launchDocument(contentLaunchParams, launchInstrumentationParams)];
            case 18:
                result = _p.sent();
                _p.label = 19;
            case 19: return [3 /*break*/, 22];
            case 20:
                error_1 = _p.sent();
                _b = getErrorInfo(error_1), debugInfo = _b.debugInfo, message = _b.message;
                logError({
                    debugInfo: debugInfo,
                    errorType: 'LaunchContent_Error',
                    eventName: eventName,
                    message: message,
                });
                // Add exception information to debug
                params["Error" /* InstrumentationParam.Error */] = message;
                params["DebugInfo" /* InstrumentationParam.DebugInfo */] = debugInfo;
                return [3 /*break*/, 22];
            case 21:
                logFeature({
                    eventName: eventName,
                    featureName: "LauncherService" /* KnownFeatureNames.LauncherService */,
                    params: {
                        AppLaunchResult: (_d = result.result) !== null && _d !== void 0 ? _d : '',
                        BuildId: buildId,
                        DocumentType: (_f = (_e = contentLaunchParams.document) === null || _e === void 0 ? void 0 : _e.fileType) !== null && _f !== void 0 ? _f : '',
                        ErrorCode: (_g = result.errorCode) !== null && _g !== void 0 ? _g : '',
                        Message: (_h = result.message) !== null && _h !== void 0 ? _h : '',
                        Success: result.success,
                    },
                });
                if (!result.success) {
                    // document information
                    if (getAppSecurityLevel() >= DataSecurityLevel.Enhanced) {
                        params["ReferralPlatform" /* InstrumentationParam.ReferralPlatform */] =
                            contentLaunchParams.document
                                ? contentLaunchParams.document.isLocalFile
                                    ? 'Native'
                                    : 'Web'
                                : ' Unknown';
                    }
                    // Launch result
                    params['AdditionalInfo'] = (_j = result.additionalInfo) !== null && _j !== void 0 ? _j : '';
                    params['BuildId'] = buildId;
                    params['ErrorCode'] = (_k = result.errorCode) !== null && _k !== void 0 ? _k : '';
                    params['ErrorCodeMessage'] = (_l = result.errorMessage) !== null && _l !== void 0 ? _l : '';
                    params['Message'] = (_m = result.message) !== null && _m !== void 0 ? _m : '';
                    params["DocumentType" /* InstrumentationParam.DocumentType */] =
                        (_o = contentLaunchParams.document) === null || _o === void 0 ? void 0 : _o.fileType;
                    logDiagnostic({
                        eventName: eventName,
                        params: params,
                    }, dataSecurityLevel);
                    // $TODO: Remove when Otel is enabled
                    logDebugCacheEvent(eventName, params, [], dataSecurityLevel);
                }
                return [7 /*endfinally*/];
            case 22: return [2 /*return*/, result];
        }
    });
}); };
//# sourceMappingURL=launchContent.js.map